import { UserDto } from '@app/generated/model';
import { UserActions, UserActionTypes } from '@dwo/actions';
import { User } from '@admin/models/user';
import { UserDetails } from '@admin/models/user-details';

export const initialState: UserState = {
  allUsers: [],
  filter: '',
  currentUser: {
    authorizations: [],
    division: 'OFFSHORE',
    email: '',
    fullName: '',
    admin: false,
    projects: [],
    role: null,
    sites: [],
    username: '',
    workCenters: [],
  },
  userDetails: null,
  projectUsers: [],
  companyUsers: [],
};

export interface UserState {
  allUsers: User[];
  filter: string;
  currentUser: UserDto;
  userDetails: UserDetails;
  projectUsers: UserDto[];
  companyUsers: UserDto[];
}

export function userReducer(state: UserState = initialState, action: UserActions): UserState {
  switch (action.type) {
    case UserActionTypes.CurrentUserLoadSuccess:
      return {
        ...state,
        currentUser: action.currentUser,
      };
    case UserActionTypes.LoadAllUsersSuccess:
      return {
        ...state,
        allUsers: action.allUsers,
      };
    case UserActionTypes.FilterUsers:
      return {
        ...state,
        filter: action.filter,
      };
    case UserActionTypes.LoadUserDetailsSuccess:
      return {
        ...state,
        userDetails: action.userDetail,
      };
    default:
      return state;
  }
}
